import { mapActions, mapState } from 'pinia'

import Footer from '@/components/Footer.vue'
import Header from '@/components/header/Header.vue'
import Loader from '@/components/Loader.vue'
import FooterDetails from '@/pages/FooterDetails.vue'
import Track from '@/pages/Track.vue'
import { useMainStore } from '@/store/main'

const HEADER_CONFIG = {
  isHomePage: false,
  isFullHeader: false,
  searchBoxVisibility: true
}

export default {
  name: 'App',
  components: {
    Header,
    Footer,
    Track,
    Loader,
    FooterDetails
  },
  data () {
    return {
      headerConfig: { ...HEADER_CONFIG },
      isSticky: false,
      isForceSticky: false,
      isHeaderHidden: false,
      lastScrollPosition: 0
    }
  },
  computed: {
    ...mapState(useMainStore, ['isMobile', 'isNavOpen']),
    ...mapState(useMainStore, ['loader']),
    headerClass () {
      const additionalClass = []

      if (this.headerConfig.isFullHeader) {
        additionalClass.push('full-header')
      }

      if (this.isSticky) {
        additionalClass.push('sticky')
      }

      if (this.isHeaderHidden) {
        additionalClass.push('header-hidden')
      }

      return additionalClass.join(' ')
    },
    currentRouteName () {
      return this.$route.name
    },
    checkFooterDisplay () {
      return !['GeneralForm', 'ApplicationForm'].includes(this.currentRouteName)
    }
  },
  methods: {
    ...mapActions(useMainStore, ['handleScroll', 'getScreenSize']),
    handleHeader (config) {
      this.headerConfig = {
        ...HEADER_CONFIG,
        ...config
      }
    },
    
    handleStickyHeader () {
      const sentinalEl = document.querySelector('.sentinal')
      if (!sentinalEl) return 

      if (this._headerObserver) {
        this._headerObserver.disconnect()
      }

      const handler = (entries) => {
        if (!this.isForceSticky && this.headerConfig.searchBoxVisibility && !this.isNavOpen) {
          const wasSticky = this.isSticky
          this.isSticky = !entries[0].isIntersecting
          
          if (this.isMobile && !wasSticky && this.isSticky) {
            this.isHeaderHidden = true
          } else if (!this.isSticky) {
            this.isHeaderHidden = false
          }
        }
      }

      this._headerObserver = new window.IntersectionObserver(handler)
      this._headerObserver.observe(sentinalEl)
    },

    scroll () {
      const applyBtn = document.querySelector('.job-detail__apply-btn')

      if (applyBtn && this.isMobile) {
        window.addEventListener('scroll', this.handleScroll)
      } else {
        window.removeEventListener('scroll', this.handleScroll)
      }
    },
    updateStickyHeader (data) {
      this.isForceSticky = data
      this.isSticky = data
    },
    handleScrollDirection () {
      const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
      if (currentScrollPosition <= 0) {
        this.isHeaderHidden = false
        this.lastScrollPosition = 0
        return
      }

      const diff = currentScrollPosition - this.lastScrollPosition
      if (Math.abs(diff) < 10) return

      if (diff > 0 && this.isSticky && this.isMobile) {
        this.isHeaderHidden = true
      } else if (diff < 0 || !this.isMobile) {
        this.isHeaderHidden = false
      }

      this.lastScrollPosition = currentScrollPosition
    }
  },
  updated () {
    this.handleStickyHeader()
    this.scroll()
  },
  created () {
    window.addEventListener('resize', this.getScreenSize)
    window.addEventListener('scroll', this.handleScrollDirection)
  },
  watch: {
    headerConfig () {
      if (!this.headerConfig.searchBoxVisibility) {
        this.isSticky = false
        // this.$store.commit('toggleReferralNav')
      }
    },
    isNavOpen () {
      this.isSticky = this.isNavOpen
    }
  },
  unmounted () { window.removeEventListener('resize', this.getScreenSize);window.removeEventListener('scroll', this.handleScrollDirection)
  }
}
